'use client';

import { getPrescriptionTypeAll } from '@/api/product';
import { IBaseCartData, IBaseCartGoodsItem } from '@/api/types/cart';
import { BasePresTypeList } from '@/app/[variants]/_lens-components/types';
import Dialog from '@/components/Dialog';
import { EPrescriptionType } from '@/utils/enums/goods';
import { useEffect, useState } from 'react';
import ClientPage from './ClientPage';

export default function LensProcessDialog({
  open,
  reloadCart,
  onClose,
  cartItemData,
}: {
  open: boolean;
  // 完成更新购物车后调用
  reloadCart?: (data: IBaseCartData, cartId: number) => void;
  // 关闭弹窗或完成流程后都调用
  onClose?: (cartId: number) => void;
  cartItemData: IBaseCartGoodsItem;
}) {
  const [glassPresTypeList, setGlassPresTypeList] = useState<BasePresTypeList>([]);

  useEffect(() => {
    if (cartItemData?.product?.prescription_type?.length) {
      getPrescriptionTypeAll().then((res) => {
        const presTypeAll = res.data;
        const innerGlassPresTypeList: BasePresTypeList = [];
        presTypeAll.forEach((el) => {
          if (
            cartItemData.product.prescription_type.includes(el.title) &&
            el.title !== EPrescriptionType.FRAME_ONLY
          ) {
            innerGlassPresTypeList.push(el);
          }
        });
        setGlassPresTypeList(innerGlassPresTypeList);
      });
    }
  }, [cartItemData]);

  return (
    // h-[100vh] 在手机浏览器上是个坑，会把地址栏高度给计算进去
    // TODO 研究一下竞品是如何处理这个问题的
    <Dialog
      open={open}
      hideHeader
      className="w-[100vw] h-[100%] !z-[450]"
      contentProps={{
        // 注意：这个className 会被引用，不要删除！！！
        className: 'lens-process-dialog-content',
      }}
      footer={null}
      sx={{
        '& .MuiPaper-root': {
          margin: 0,
          width: '100vw',
          height: '100%',
          maxWidth: '100vw',
          borderRadius: 0,
        },
        '& .MuiDialogContent-root': {
          padding: 0,
          maxHeight: '100%',
          height: '100%',
        },
      }}
    >
      <ClientPage
        cartItemData={cartItemData}
        isRedeem={false}
        glassPresTypeList={glassPresTypeList}
        onUpdateCart={(data) => {
          reloadCart?.(data, cartItemData.cart_id);
        }}
        onClose={() => {
          onClose?.(cartItemData.cart_id);
          setGlassPresTypeList([]);
        }}
        inDialog
      />
    </Dialog>
  );
}
